// Recovered compiled webpack factory 45242. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { f: () => n });
  function n(t, e) {
    return e ? (1e3 / e) * t : 0;
  }
}
